/**
 * Telegram Mini App — Lesson Session
 *
 * Wraps MicroLearningModule for full lesson experience inside Telegram.
 * URL: /tg/lesson/:moduleId?subject=X&topic=Y
 *
 * Features: All component types (Intel, Defs, Practice, Quiz, ESLCE),
 * AIHelpPanel built-in, progress tracking, review mode.
 */

import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import TelegramShell from '../components/TelegramShell';
import MicroLearningModule from '../components/MicroLearning/MicroLearningModule';
import './TelegramLesson.css';

const TelegramLessonInner: React.FC = () => {
  const { moduleId } = useParams<{ moduleId: string }>();
  const [searchParams] = useSearchParams();
  const { student, isLoading } = useAuth();

  const subject = searchParams.get('subject') || undefined;
  const topic = searchParams.get('topic') || undefined;
  const mode = searchParams.get('mode') || undefined; // quiz_only, content_only
  const review = searchParams.get('review') === 'true';

  if (isLoading) {
    return (
      <div className="tg-lesson-loading">
        <p>Loading lesson...</p>
      </div>
    );
  }

  const studentId = student?.student_id || 'guest';

  return (
    <div className="tg-lesson">
      <MicroLearningModule
        studentId={studentId}
        subject={subject}
        topic={topic}
        moduleId={moduleId}
        reviewMode={review}
        onModuleComplete={() => {
          // Close Mini App when lesson is complete
          window.Telegram?.WebApp?.close();
        }}
        onExit={() => {
          window.Telegram?.WebApp?.close();
        }}
      />
    </div>
  );
};

const TelegramLesson: React.FC = () => {
  return (
    <TelegramShell>
      <TelegramLessonInner />
    </TelegramShell>
  );
};

export default TelegramLesson;
